import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectorCoreSelectedInstance } from './core.reducer';
import { environment } from 'apps/smart-app/src/environments/environment';
import { Environment, ENVIRONMENT } from './core.models';

declare var ga: Function;

@Injectable()
export class GoogleAnalyticsEventsService {
  private store = inject<Store<any>>(Store);
  private env = inject<Environment>(ENVIRONMENT);

  instanceUrl: string;
  version: string;

  constructor() {
    const store = this.store;

    store
      .pipe(
        select(selectorCoreSelectedInstance),
        filter(selectedInstance => !!selectedInstance)
      )
      .subscribe(selectedInstance => (this.instanceUrl = selectedInstance.url));
  }
  initGA(): void {
    ga(function (tracker) {
      if (!localStorage.getItem('clientId')) {
        localStorage.setItem('clientId', tracker.get('clientId'));
      }
    });
    ga('create', {
      trackingId: 'UA-74615013-1',
      storage: 'none',
      clientId: localStorage.getItem('clientId')
    });
    this.version = this.env.version;
    ga('set', 'dimension1', this.instanceUrl);
    ga('set', 'dimension3', 'App');
    ga('set', 'dimension5', this.version);
    ga('set', 'checkProtocolTask', null);
    ga('set', 'transportUrl', 'https://www.google-analytics.com/collect');
  }

  setInstance(instanceUrl: string): void {
    instanceUrl = instanceUrl.replace('https://', '');
    ga('set', 'dimension1', instanceUrl);
  }

  setUserData(uuid: string, userConfig: any): void {
    const userType = userConfig['is_pro'] ? 'Pro' : 'Patient';
    ga('set', 'dimension2', userType);
    ga('set', 'dimension4', uuid);
    ga('set', 'dimension6', this.getUserGroupsAsString(userConfig));
    ga('set', 'userId', uuid);
  }

  getUserGroupsAsString(user: any): string {
    return user && user['groups']
      ? user['groups']
          .map(function (group) {
            return group.title;
          })
          .toString()
      : '';
  }

  emitEvent(event: any, extra?: string): void {
    const eventCategory = event.ga.data.eventCategory || '';
    const eventAction = event.ga.data.eventAction || '';
    const eventLabel = extra || event.ga.data.eventLabel || null;
    const eventValue = event.ga.data.eventValue || null;
    ga('send', 'event', { eventCategory, eventLabel, eventAction, eventValue });
  }

  emitPageTrack(page: any): void {
    ga('send', 'pageview', page);
  }

  emitFormTrack(url: any): void {
    if (url.indexOf('/;end_js') === -1) {
      const parsedUrl = url.slice(0, url.indexOf('activities/'));
      ga('send', 'event', 'Forms', parsedUrl, 'Save');
    }
  }
}
